import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['projects', 'projectsLoader']

  connect() {
    this.loadProjects();
  }

  onProjectChange() {
    // Hook for future use if needed
  }

  loadProjects() {
    this.projectsTarget.options.length = 0;
    fetch(this.data.get('accountPath') + '/basecamp_projects.json', {
      method: 'GET',
      credentials: 'same-origin'
    }).then((response) => {
      return response.json();
    }).then((response) => {
      for(var index in response) {
        this.projectsTarget.options[this.projectsTarget.options.length] = new Option(response[index][0], response[index][1] + ":" + response[index][0]);
        if (this.data.get("projectId") == response[index][1]) {
          this.projectsTarget.selectedIndex = this.projectsTarget.options.length - 1
        }
      }

      this.projectsTarget.style.display = 'block';
      this.projectsLoaderTarget.style.display = 'none';
    })
  }

  selectedProjectId() {
    return this.projectsTarget.options[this.projectsTarget.selectedIndex].value.split(':')[0];
  }
}
